import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: '',
    component: () => import('@/views/home/Home.vue'),
  },
  {
    path: '/custom',
    name: '',
    component: () => import('@/views/home/Custome.vue'),
  },
  {
    path: '/service',
    name: '服务',
    component: () => import('@/views/Layout.vue'),
    children: [
      {
        path: '',
        name: '全部服务',
        component: () => import('@/views/service/Service.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: '/service/detail/:type/:id(\\d+)',
        name: '',
        component: () => import('@/views/service/Detail.vue'),
        meta: {
          isShowTabbar: false,
        },
      },
      {
        path: '/service/detail/card/:id(\\d+)',
        name: '卡项详情',
        component: () => import('@/views/service/DetailCard.vue'),
      },
    ],
  },
  {
    path: '/my',
    name: '我的',
    component: () => import('@/views/Layout.vue'),
    children: [
      {
        path: '',
        name: '我的',
        component: () => import('@/views/my/index.vue'),
      },
      {
        path: '/my/setting',
        name: '系统设置',
        component: () => import('@/views/my/Setting.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: '/my/user-info',
        name: '个人信息',
        component: () => import('@/views/my/UserInfo.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: '/my/appointment',
        name: '预约单',
        component: () => import('@/views/my/Appointment.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: '/my/appointment-detail',
        name: '预约详情',
        component: () => import('@/views/my/AppointmentDetail.vue'),
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: '/appointment',
    name: '预约',
    component: () => import('@/views/appointment/index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/success',
    name: '预约成功',
    component: () => import('@/views/Success.vue'),
  },
  {
    path: '/store-detail',
    name: '店铺信息',
    component: () => import('@/views/StoreDetail.vue'),
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('@/views/Login.vue'),
    meta: {
      isShowTabbar: false,
    },
  },
  {
    path: '/store-error',
    name: '',
    component: () => import('@/views/StoreError.vue'),
    meta: {
      isShowTabbar: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
